import { useI18n } from '../i18n/useI18n'
import { displayOrderNumber } from '../lib/orderNumber'
import type { Order } from '../store/useStore'

/**
 * #1215 受け取りパス — 客がカウンターで提示する番号 + QR (店内飲食・持ち帰り共通)。
 *
 * 設計方針は「番号が主、通知が従」。番号は大きく出してスタッフが口頭で呼べる/
 * 目視照合できるようにし、QR は受け渡し完了をワンタップで記録したい店向けの
 * 補助 (スタッフが読むと picked_up になる)。
 *
 * QR 取得に失敗しても番号は必ず出す — 番号さえ見えれば受け取りは成立する。
 */
export default function PickupPassCard({ order }: { order: Order }) {
  const { t } = useI18n()
  const isReady = order.status === 'ready'

  return (
    <div
      className={`mx-4 mt-3 rounded-2xl border-2 p-4 text-center ${
        isReady ? 'border-matcha bg-matcha/5' : 'border-gray-200 bg-white'
      }`}
    >
      <p className="font-body text-xs font-medium text-text-secondary">
        {isReady ? t('pickup.readyTitle') : t('pickup.waitingTitle')}
      </p>
      <p
        className={`mt-1 font-display text-5xl font-bold ${
          isReady ? 'text-matcha' : 'text-text-primary'
        }`}
      >
        {displayOrderNumber(order)}
      </p>
      <p className="mt-1 font-body text-[11px] text-text-tertiary">
        {isReady ? t('pickup.readyHint') : t('pickup.waitingHint')}
      </p>
    </div>
  )
}
